import { BehaviorSubject, delay, Observable, of, switchMap, tap } from 'rxjs';
import { ControlError, ControlRecordGroups } from '../../types/control';
import { COLLAPSE_ANIMATION_TIMEOUT } from '../../config/animation';

export function getDefaultGroups(): ControlRecordGroups {
  return {
    error: [],
    warning: [],
    info: [],
  };
}

export function delayIfCollapsed(collapsed$: BehaviorSubject<boolean>) {
  return function (stream$: Observable<ControlError>) {
    return stream$.pipe(
      switchMap(value => {
        if (collapsed$.value) {
          return of(value).pipe(
            tap(() => {
              collapsed$.next(false);
            }),
            delay(COLLAPSE_ANIMATION_TIMEOUT),
          );
        }
        return of(value);
      }),
    );
  };
}
